// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__2VAWk","form":"styles_form__1YGH0"};